<template>
<v-layout row class="align-center layout pl-0 pt-0 app--page-header page-header-shell">
    <div class="page-header-left">
        <v-breadcrumbs divider="/" :items="breadcrumbs" class="page-header-breadcrumbs pa-0">
            <template v-slot:item="props">
                <v-breadcrumbs-item :href="props.item.href" :class="[props.item.disabled && 'disabled']">
                    <h3 class="page-header-title text-subtitle-1 font-weight-medium pl-3">{{ props.item.text }}</h3>
                </v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>
        <template v-if="breadcrumbs.length == 0">
            <v-breadcrumbs class="page-header-breadcrumbs pa-0">
                <v-breadcrumbs-item>
                    <h3 class="page-header-title">{{ routeName }}</h3>
                </v-breadcrumbs-item>
            </v-breadcrumbs>
        </template>
    </div>
    <v-spacer></v-spacer>
    <div class="page-header-right pr-0 d-flex align-center">
        <v-btn depressed class="page-header-btn page-header-btn--mint rounded-lg font-weight-bold text-capitalize" v-if="$route.meta.importButton && !options.invisibleImportButton" @click="importAction">
            <v-icon left size="18">{{$route.meta.importButtonIcon ? $route.meta.importButtonIcon : 'upload'}}</v-icon> {{$route.meta.importButtonText ? $route.meta.importButtonText : $t('actions.import')}}
        </v-btn>
        <v-btn depressed class="page-header-btn page-header-btn--mint rounded-lg font-weight-bold text-capitalize" v-if="$route.meta.exportButton && !options.invisibleExportButton" @click="exportAction">
            <v-icon left size="18">{{$route.meta.exportButtonIcon ? $route.meta.exportButtonIcon : 'download'}}</v-icon> {{$route.meta.exportButtonText ? $route.meta.exportButtonText : $t('actions.export')}}
        </v-btn>
        <v-btn depressed class="page-header-btn page-header-btn--emerald rounded-lg font-weight-bold text-capitalize elevation-1" v-if="$route.meta.saveButton && !options.invisibleSaveButton" @click="saveData" v-shortkey.once="['ctrl', 's']" @shortkey="saveData">
            <v-icon left size="18">{{$route.meta.saveButtonIcon ? $route.meta.saveButtonIcon : 'save'}}</v-icon> {{$route.meta.saveButtonText ? $route.meta.saveButtonText : $t('actions.save')}}
        </v-btn>
        <v-btn depressed class="page-header-btn page-header-btn--blue rounded-lg font-weight-bold text-capitalize elevation-1" v-if="$route.meta.createButton && !options.invisibleCreateButton" @click="createData" v-shortkey.once="['alt', 'n']" @shortkey="createData">
            <v-icon left size="18">{{$route.meta.createButtonIcon ? $route.meta.createButtonIcon : 'add'}}</v-icon> {{$route.meta.createButtonText ? $route.meta.createButtonText : $t('actions.add')}}
        </v-btn>
        <v-btn depressed class="page-header-btn page-header-btn--slate rounded-lg font-weight-bold text-capitalize" v-if="$route.meta.refreshButton" @click="refreshData" v-shortkey.once="['alt','f5']" @shortkey="refreshData">
            <v-icon left size="18">refresh</v-icon> {{$t('actions.refresh')}}
        </v-btn>
    </div>
</v-layout>
</template>

<script>
import menu from "@/api/menu";
import paths from "@/router/paths";
import {
    buildBreadcrumb
} from "@/commons/utils";
export default {
     data() {
        return {
            options: {}
        }
     },
    computed: {
        routeName() {
            if (this.$route.meta.titleKey) {
                return this.$t(`${this.$route.meta.titleKey}`);
            }
            var title = this.$route.meta.title ? this.$route.meta.title : this.$route.params.title;
            return title ? title : this.$route.name;
        },
        breadcrumbs: function () {
            let breadcrumbs = [];
            if(this.$route.params.manualTitle) {
                return breadcrumbs;
            }
            let routeName = this.$route.name;
            breadcrumbs = buildBreadcrumb(routeName, this.$route.path, this.$route.params.Pid, this.$route.params.titleKey, menu, paths);
            return breadcrumbs;
        }
    },
    methods: {
        exportAction() {
            window.getApp.$emit('EXPORT_ACTION');
        },
        importAction() {
            window.getApp.$emit('IMPORT_ACTION');
        },
        saveData() {
            window.getApp.$emit('PRE_SAVE_DATA');
        },
        createData() {
          this.$root.$emit('REQUEST_CREATE_DATA');
        },
        refreshData() {
          this.$root.$emit('REQUEST_REFRESH_DATA');
        },
        changeOption(options) {
            this.options = options;
        }
    },
    mounted() {
        this.$root.$on("REQUEST_ROOT_OPTION", this.changeOption);
    }
};
</script>

<style scoped>
.page-header-shell {
    margin: 0 26px 0 26px !important;
    padding: 8px 16px !important;
    border: 1px solid #dbe4ee;
    border-radius: 14px;
    background: #ffffff;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
}

.page-header-left {
    display: flex;
    align-items: center;
    min-height: 40px;
}

.page-header-breadcrumbs {
    padding: 0 !important;
}

.page-header-breadcrumbs :deep(.v-breadcrumbs__item),
.page-header-breadcrumbs :deep(.v-breadcrumbs__divider) {
    display: inline-flex;
    align-items: center;
}

.page-header-breadcrumbs :deep(.v-breadcrumbs__item) {
    line-height: 1.2;
}

.page-header-title {
    margin: 0;
    color: #64748b;
    line-height: 1.2;
}

.page-header-right {
    min-height: 40px;
    flex-wrap: wrap;
    gap: 8px;
}

.page-header-btn {
    min-height: 16px !important;
    margin-left: 0 !important;
    padding: 0 18px !important;
    font-size: 12px !important;
    letter-spacing: 0.01em;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08) !important;
}

.page-header-btn--mint {
    background: linear-gradient(135deg, #22c55e, #14b8a6) !important;
    color: #ffffff !important;
}

.page-header-btn--emerald {
    background: linear-gradient(135deg, #16a34a, #22c55e) !important;
    color: #ffffff !important;
   
}

.page-header-btn--blue {
    background: linear-gradient(135deg, #2563eb, #38bdf8) !important;
    color: #ffffff !important;
}

.page-header-btn--slate {
    background: linear-gradient(135deg, #e0e0e0, #c9c9c9) !important;
    color: #334155 !important;
}
</style>
